import { withPluginApi } from "discourse/lib/plugin-api";

const PLUGIN_ID = "discourse-ai";

export default {
  name: "discourse-ai-admin-plugin-configuration-nav",

  initialize(container) {
    const currentUser = container.lookup("service:current-user");
    if (!currentUser || !currentUser.admin) {
      return;
    }

    withPluginApi((api) => {
      api.setAdminPluginIcon(PLUGIN_ID, "discourse-sparkles");
      api.addAdminPluginConfigurationNav(PLUGIN_ID, [
        {
          label: "discourse_ai.features.short_title",
          route: "adminPlugins.show.discourse-ai-features",
          description: "discourse_ai.features.description",
        },
        {
          label: "discourse_ai.usage.short_title",
          route: "adminPlugins.show.discourse-ai-usage",
          description: "discourse_ai.usage.subheader_description",
        },
        {
          label: "discourse_ai.llms.short_title",
          route: "adminPlugins.show.discourse-ai-llms",
          description: "discourse_ai.llms.preconfigured.description",
        },
        {
          label: "discourse_ai.secrets.short_title",
          route: "adminPlugins.show.discourse-ai-secrets",
          description: "discourse_ai.secrets.description",
        },
        {
          label: "discourse_ai.ai_agent.short_title",
          route: "adminPlugins.show.discourse-ai-agents",
          description: "discourse_ai.ai_agent.agent_description",
        },
        {
          label: "discourse_ai.embeddings.short_title",
          route: "adminPlugins.show.discourse-ai-embeddings",
          description: "discourse_ai.embeddings.description",
        },
        {
          label: "discourse_ai.tools.short_title",
          route: "adminPlugins.show.discourse-ai-tools",
          description: "discourse_ai.tools.subheader_description",
          keywords: "discourse_ai.tools.keywords",
        },
        {
          label: "discourse_ai.spam.short_title",
          route: "adminPlugins.show.discourse-ai-spam",
          description: "discourse_ai.spam.spam_description",
        },
        {
          label: "discourse_ai.translations.title",
          route: "adminPlugins.show.discourse-ai-translations",
          description: "discourse_ai.translations.description",
        },
        {
          label: "discourse_ai.logs.short_title",
          route: "adminPlugins.show.discourse-ai-logs",
          description: "discourse_ai.logs.description",
        },
      ]);
    });
  },
};
